/**
 * Photos are scaled down on the device before they leave it: big enough to read a timetable
 * or a cookbook page, small to send (≈ 1600 px, JPEG).
 */
export async function shrink(
  file: File,
  maxSide = 1600,
  quality = 0.82,
): Promise<{ mimeType: 'image/jpeg'; data: string; url: string }> {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d')!.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  const url = canvas.toDataURL('image/jpeg', quality);
  return { mimeType: 'image/jpeg', data: url.split(',')[1]!, url };
}
